
export default {
  name: 'Btn',
  emits: ['click'],
  components: {},
  data: () => ({
    hover: false
  }),
  props: {
    isSlot: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    label: {
      type: String,
      required: false
    },
    type: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    iconStyle: {
      type: Boolean,
      default: false
    },
    variant: {
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'secondary-link', 'secondary-white', 'mobile-arrow'].includes(value)
      }
    },
    icon: {
      type: String,
      default: ''
    },
    iconPos: {
      validator(value) {
        return ['left', 'right'].includes(value)
      }
    },
    isInverted: {
      type: Boolean,
      default: false
    },
    isFullWidth: {
      type: Boolean,
      default: true
    },
    tag: {
      default: 'button',
      type: String
    },
    to: {
      default: '#',
      type: String
    },
    external: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
      default: 'button'
    },
    isUppercase: {
      type: Boolean,
      default: true
    },
    isBold: {
      type: Boolean,
      default: false
    },
    roundedBorder: {
      type: Boolean,
      default: false
    },
    font: {
      type: String,
      default: ''
    },
    size: {
      default: 'sm',
      validator(value) {
        return ['sm', 'md'].includes(value)
      }
    }
  },
  computed: {
    dynamicProps() {
      let externalLink = {}
      if (this.tag === 'a') {
        externalLink = {href: this.to, target: this.external ? '_blank' : '_self'}
      } else if (this.tag === 'button') {
        externalLink = {role: this.role}
      }
      return externalLink
    },
    classes() {
      const isPrimary = this.variant === 'primary'
      const isDark = this.variant === 'primary-dark'
      const isSecondary = this.variant === 'secondary'
      const isSecondaryLink = this.variant === 'secondary-link'
      const isSecondaryWhite = this.variant === 'secondary-white'
      const isMobileArrow = this.variant === 'mobile-arrow'
      const isSmall = this.size === 'sm'
      const isMedium = this.size === 'md'
      return {
        'btn-primary': isPrimary || isMobileArrow,
        'btn-secondary': isSecondary,
        'btn-secondary-link': isSecondaryLink,
        'btn-secondary-white': isSecondaryWhite,
        'btn-mobile-arrow': isMobileArrow,
        'btn-dark': isDark,
        'btn-sm': isSmall,
        'btn-md': isMedium,
        'text-uppercase': this.isUppercase,
        'text-bold': this.isBold,
        'rounded-border': this.roundedBorder,
        'full-width': this.isFullWidth,
        'width-auto': !this.isFullWidth
      }
    },
    classTxt() {
      return {
        'text-uppercase': this.isUppercase,
        'text-bold': this.isBold,
        'font-gotham': this.font === 'Gotham'
      }
    }
  },
  methods: {
    emitEvent(e) {
      this.$emit('click', e)
    }
  }
}
